import { Tree } from 'antd';
import { type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type GetVariantsOfAllConfiguratorsQuery } from '../../../../api/queries/getVariantsOfAllConfigurators';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import useTranslatedString from '../../../../utilities/useTranslatedString';

export type VehicleListSectionProps = {
    vehicles: GetVariantsOfAllConfiguratorsQuery['vehicles'];
    header: ReactNode;
    name: string;
    disabled?: boolean;
};

const VehicleListSection = ({ vehicles, header, name, disabled }: VehicleListSectionProps) => {
    const { t } = useTranslation(['configuratorModuleDetail']);
    const translatedString = useTranslatedString();

    const treeData = useMemo(
        () => [
            {
                key: 1,
                title: t('configuratorModuleDetail:variants'),
                children: vehicles.map(vehicle => ({
                    key: vehicle.id,
                    title: translatedString(vehicle.name),
                })),
            },
        ],
        [vehicles, translatedString, t]
    );

    return (
        <CollapsibleWrapper defaultActiveKey={name}>
            <Panel key={name} header={header}>
                <Tree disabled={disabled} selectable={false} treeData={treeData} autoExpandParent defaultExpandAll />
            </Panel>
        </CollapsibleWrapper>
    );
};

export default VehicleListSection;
